import React from 'react'
import OwlCarousel from 'react-owl-carousel'
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import productdetail from './productdetails';
import productdetail2 from './productdetails2';

export const Home = ({ cart, setCart }) => {

  const savingarry = (store) => {
    setCart([...cart, store])
  }

  return (
    <div className='homemain'>
      <div className="carousel">
        <div id="carouselExampleRide" class="carousel slide" data-bs-ride="true">
          <div class="carousel-inner">
            <div class="carousel-item active" data-bs-interval="5000">
              <img src={require('./Images/slide1.webp')} class="d-block w-100" alt="..." />
              <div className='position-absolute top-50 translate-middle' id='herocon'>
                <h5 className='fw-semibold'>NEW COLLECTION</h5>
                <h2 className='fw-bolder mt-2 mb-2'>MEN'S FASHION 2024</h2>
                <h6>STARTING AT $65.00. DON'T MISS OUT!</h6>
                <p className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elite, <br /> Dolorum beatae in saepe ipsam impedit dignissimos, harum eligendi qui ab at repellat.</p>
                <button id='herobtn'>SHOP NOW</button>
              </div>
            </div>
            <div class="carousel-item" data-bs-interval="5000">
              <img src={require('./Images/slide2.webp')} class="d-block w-100" alt="..." />
              <div className='position-absolute top-50 translate-middle' id='herocon'>
                <h5 className='fw-semibold'>NEW COLLECTION</h5>
                <h2 className='fw-bolder mt-2 mb-2'>MEN'S FASHION 2024</h2>
                <h6>STARTING AT $65.00. DON'T MISS OUT!</h6>
                <p className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elite, <br /> Dolorum beatae in saepe ipsam impedit dignissimos, harum eligendi qui ab at repellat.</p>
                <button id='herobtn'>SHOP NOW</button>
              </div>
            </div>
          </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleRide" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleRide" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <div className="shopcollect d-flex container mx-auto justify-content-between  ps-4 pe-4" id='shopcollect'>
        <div className='c1'>
          <img src={require('./Images/c1.webp')} alt="" />
        </div>
        <div className="c2">
          <div>
            <h4>Fashion Collection 2024</h4>
            <p>BIG SALE OF THE MEN 2021 FASHION <br />UP TO 23% OFF!</p>
            <a href="">Shop Now</a>
          </div>
          <img src={require('./Images/c2.webp')} alt="" />
        </div>
        <div className="c3">
          <img src={require('./Images/c3.webp')} alt="" />
          <div>
            <h4>Men's Collection 2024</h4>
            <p>There are many variations of passages of Lorem Ipsum <br /> avalabbut the majority have suffered alteration in some form.</p>
            <a href="">Shop Now</a>
          </div>
        </div>
      </div>
      <div className="featureproduct">
        <div className="fhead text-center">
          <h3 className='fw-semibold'>Feature Products</h3>
        </div>
        <div className="fproduct row contanier mx-auto justify-content-center gap-lg-4">
          {
            productdetail.map((ss, index) =>
              <div key={index} className='col-lg-3 text-center' id='width'>
                <div class="card">
                  <img src={ss.image} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">{ss.title}</h6>
                    <h5>$ {ss.price}</h5>
                    <div className="cartbutton position-absolute start-50 translate-middle d-flex gap-lg-2">
                      <div><button class="" onClick={() => savingarry(ss)}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-cart-check" viewBox="0 0 16 16">
                        <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                        <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                      </svg></button></div>
                      <div><button><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                      </svg></button></div>
                      <div><button><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg></button></div>
                    </div>

                  </div>
                </div>
              </div>
            )
          }
        </div>
        <div className="fproductmore text-center mt-5">
          <button>LOAD MORE</button>
        </div>
      </div>
      <div className="productdisplay d-flex contanier mx-auto justify-content-around position-relative" id='productdisplay'>
        <div className='pdsub1'>
          <div>
            <img src={require('./Images/s1.webp')} alt="" />
          </div>
          <div className='mt-3'>
            <img src={require('./Images/s2.webp')} alt="" />
          </div>
        </div>
        <div className="pdsub2 position-absolute">
          <img src={require('./Images/l1.webp')} alt="" />
        </div>
        <div className="pdsub3 text-secondary ps-5">
          <h5 className='text-secondary fw-bold mt-5 mb-3'>THE MAKER USC DRESS</h5>
          <h4>$569.00 <span>$669.00</span></h4>
          <p className='mt-4 mb-4'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed does eiusmodes tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venim, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodoes tempor incididunt ut labore et dolore magna aliqua. consequat. Ut enim ad minim veniam.</p>
          <h6>SIZE <span className='ms-5 ps-4'>: S M L XL</span></h6>
          <h6>COLOR <span className='ms-5'>: Red Green Blue</span></h6>
          <h6>BRAND <span className='ms-5'>: Addidas Puma Nike</span></h6>
          <h6>CATEGORY <span className='ms-3'>: Men's Fashion</span></h6>
        </div>
      </div>
      <div className="newproduct">
        <div className="newarrivalhead text-center">
          <h3 className='fw-semibold'>New Arrival // <span className='text-secondary'>Popular Product // Best Seller</span></h3>
        </div>
        <div className="fproduct row contanier mx-auto justify-content-center gap-lg-4">
          {
            productdetail2.map((ss, index) =>
              <div key={index} className='col-lg-3 text-center' id='width'>
                <div class="card">
                  <img src={ss.image} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">{ss.title}</h6>
                    <h5>$ {ss.price}</h5>
                    <div className="cartbutton position-absolute start-50 translate-middle d-flex gap-lg-2">
                      <div><button class="" onClick={() => savingarry(ss)}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-cart-check" viewBox="0 0 16 16">
                        <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                        <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                      </svg></button></div>
                      <div><button><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                      </svg></button></div>
                      <div><button><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg></button></div>
                    </div>

                  </div>
                </div>
              </div>
            )
          }
        </div>
        <div className="fproduct row contanier mx-auto justify-content-center gap-lg-4 mt-4">
          {
            productdetail.map((ss, index) =>
              <div key={index} className='col-lg-3 text-center' id='width'>
                <div class="card">
                  <img src={ss.image} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">{ss.title}</h6>
                    <h5>$ {ss.price}</h5>
                    <div className="cartbutton position-absolute start-50 translate-middle d-flex gap-lg-2">
                      <div><button class="" onClick={() => savingarry(ss)}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-cart-check" viewBox="0 0 16 16">
                        <path d="M11.354 6.354a.5.5 0 0 0-.708-.708L8 8.293 6.854 7.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                        <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zm3.915 10L3.102 4h10.796l-1.313 7zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                      </svg></button></div>
                      <div><button><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                      </svg></button></div>
                      <div><button><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg></button></div>
                    </div>

                  </div>
                </div>
              </div>
            )
          }
        </div>
        <div className="fproductmore text-center mt-5">
          <button>LOAD MORE</button>
        </div>
      </div>
      <div className="blog">
        <div className="bloghead text-center">
          <h3 className='fw-semibold'>Latest Blog</h3>
        </div>
        <div className="blogcards d-flex contanier mx-auto gap-lg-4" id='blogcards'>
          <div className='blogcard'>
            <div class="bc">
              <img src={require('./Images/blog1.webp')} class="card-img-top" alt="..." />
              <div class="card-body pt-3 ps-4 pe-4 pb-4">
                <h6 class="card-title">FASHION STYLE FINE ARTS DRAWING</h6>
                <p className='text secondary'>By : Rakib | 210 Like | 69 Comments</p>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content...</p>
                <a href="" className=''>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></a>
              </div>
            </div>
          </div>
          <div className='blogcard'>
            <div class="bc">
              <img src={require('./Images/blog2.webp')} class="card-img-top" alt="..." />
              <div class="card-body pt-3 ps-4 pe-4 pb-4">
                <h6 class="card-title">WOMEN'S FASHION STYLE 2024</h6>
                <p className='text secondary'>By : Rakib | 210 Like | 69 Comments</p>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content...</p>
                <a href="" className=''>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></a>
              </div>
            </div>
          </div>
          <div className='blogcard'>
            <div class="bc">
              <img src={require('./Images/blog3.webp')} class="card-img-top" alt="..." />
              <div class="card-body pt-3 ps-4 pe-4 pb-4">
                <h6 class="card-title">WOMEN'S WINTER FASHION STYLE</h6>
                <p className='text secondary'>By : Rakib | 210 Like | 69 Comments</p>
                <p class="card-text">Some quick example text to build on the card title and make up the bulk of the card's content...</p>
                <a href="" className=''>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sponerss d-flex justify-content-center mx-auto">
        <div>
          <img src={require('./Images/brand1.webp')} alt="" className='pt-2' />
        </div>
        <div>
          <img src={require('./Images/brand2.webp')} alt="" />
        </div>
        <div>
          <img src={require('./Images/brand3.webp')} alt="" />
        </div>
        <div>
          <img src={require('./Images/brand4.webp')} alt="" className='pt-1' />
        </div>
        <div>
          <img src={require('./Images/brand5.webp')} alt="" className='pt-2' />
        </div>
      </div>
      <div className="footerform d-flex mx-auto justify-content-around" id='footerform'>
        <div className='newselleter'>
          <h4 className='fw-bold'>NEWSELETTER</h4>
          <input type="email" placeholder='Enter your email address...' className='mt-3' /> <br />
          <button>SUBSCRIBE</button>
          <div className="socialmedia d-flex gap-2">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
              </svg>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
                <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
              </svg>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
              </svg>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pinterest" viewBox="0 0 16 16">
                <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0" />
              </svg>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-threads" viewBox="0 0 16 16">
                <path d="M6.321 6.016c-.27-.18-1.166-.802-1.166-.802.756-1.081 1.753-1.502 3.132-1.502.975 0 1.803.327 2.394.948s.928 1.509 1.005 2.644q.492.207.905.484c1.109.745 1.719 1.86 1.719 3.137 0 2.716-2.226 5.075-6.256 5.075C4.594 16 1 13.987 1 7.994 1 2.034 4.482 0 8.044 0 9.69 0 13.55.243 15 5.036l-1.36.353C12.516 1.974 10.163 1.43 8.006 1.43c-3.565 0-5.582 2.171-5.582 6.79 0 4.143 2.254 6.343 5.63 6.343 2.777 0 4.847-1.443 4.847-3.556 0-1.438-1.208-2.127-1.27-2.127-.236 1.234-.868 3.31-3.644 3.31-1.618 0-3.013-1.118-3.013-2.582 0-2.09 1.984-2.847 3.55-2.847.586 0 1.294.04 1.663.114 0-.637-.54-1.728-1.9-1.728-1.25 0-1.566.405-1.967.868ZM8.716 8.19c-2.04 0-2.304.87-2.304 1.416 0 .878 1.043 1.168 1.6 1.168 1.02 0 2.067-.282 2.232-2.423a6.2 6.2 0 0 0-1.528-.161" />
              </svg>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
                <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334q.002-.211-.006-.422A6.7 6.7 0 0 0 16 3.542a6.7 6.7 0 0 1-1.889.518 3.3 3.3 0 0 0 1.447-1.817 6.5 6.5 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.32 9.32 0 0 1-6.767-3.429 3.29 3.29 0 0 0 1.018 4.382A3.3 3.3 0 0 1 .64 6.575v.045a3.29 3.29 0 0 0 2.632 3.218 3.2 3.2 0 0 1-.865.115 3 3 0 0 1-.614-.057 3.28 3.28 0 0 0 3.067 2.277A6.6 6.6 0 0 1 .78 13.58a6 6 0 0 1-.78-.045A9.34 9.34 0 0 0 5.026 15" />
              </svg>
            </div>
          </div>
        </div>
        <div className='form'>
          <h4 className='fw-bold'>GET IN TOUCH</h4>
          <input type="text" name="" id="" placeholder='Enter your name...' className='mt-3 mb-2' /> <br />
          <input type="email" placeholder='Enter your email address...' className='mb-2' /> <br />
          <textarea name="" id="" placeholder='Enter your message...'></textarea> <br />
          <button>SEND MESSAGE</button>
        </div>
      </div>
      <div className="footer d-flex mx-auto justify-content-center" id='footer'>
        <div id='contactfoot'>
          <h5 className='mb-5'>CONTACT US</h5>
          <div className="d-flex gap-3">
            <div id='contactlogo'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
              </svg>
            </div>
            <div>
              <a href="">18 New York ,USA</a>
            </div>
          </div>
          <div className="d-flex gap-3 mt-2">
            <div id='contactlogo'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
              </svg>
            </div>
            <div>
              <a href="">888 555 333</a>
            </div>
          </div>
          <div className="d-flex gap-3 mt-2">
            <div id='contactlogo'>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope-fill" viewBox="0 0 16 16">
                <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
              </svg>
            </div>
            <div>
              <a href="">shellshop@gmail.com</a>
            </div>
          </div>
        </div>
        <div id='accfoot'>
          <h5 className='mb-5'>MY ACCOUNT</h5>
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>My Account</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>My Wishlist</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>My Cart</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Sign In</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Check Out</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Take My Order</a>
        </div>
        <div id='shipfoot'>
          <h5 className='mb-5'>SHIPPING</h5>
          <a href="" className=''><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>New Products</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Top Sellers</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Manufactures</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Suppliers</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Specials</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Availability</a>
        </div>
        <div id='infofoot'>
          <h5 className='mb-5'>INFORMATION</h5>
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Return Exchange</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Fast Delivery</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Online Shopping</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Shopping Guide</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Terms & Condition</a> <br />
          <a href=""><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
          </svg>Home Delivery</a>
        </div>
        <div id='instafoot'>
          <h5 className='mb-5'>INSTAGRAM</h5>
          <div className="d-flex gap-2">
            <div>
              <img src={require('./Images/in1.webp')} alt="" />
            </div>
            <div>
              <img src={require('./Images/in2.webp')} alt="" />
            </div>
            <div>
              <img src={require('./Images/in3.webp')} alt="" />
            </div>
          </div>
          <div className="d-flex gap-2 mt-2">
            <div>
              <img src={require('./Images/in4.webp')} alt="" />
            </div>
            <div>
              <img src={require('./Images/in5.webp')} alt="" />
            </div>
            <div>
              <img src={require('./Images/in6.webp')} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className=' d-flex mx-auto justify-content-around text-secondary' id='cc'>
          <div>
            <p>© 2024 <span className='fw-semibold'>Sell-Shop</span> Made By <span className='fw-semibold'>VIKRAM</span>.</p>
          </div>
          <div>
            <img src={require('./Images/payment.webp')} alt="" />
          </div>
        </div>
      </div>
    </div>
  )
}
